import React from 'react';
import { motion } from 'framer-motion';

const Cookies = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6
      }
    }
  };

  return (
    <div className="min-h-screen bg-dark-400 pt-24 pb-12">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hero Section */}
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
        >
          <h1 className="text-4xl md:text-6xl font-futuristic font-bold mb-6">
            <span className="gradient-text">Cookie Policy</span>
          </h1>
        </motion.div>

        {/* Cookie Content Section */}
        <motion.section
          className="mb-16"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
        >
          <motion.div
            className="card-glass p-8 rounded-lg max-w-4xl mx-auto"
            variants={itemVariants}
          >
            <div className="space-y-6 text-gray-300 text-lg leading-relaxed">
              <p>Our website uses cookies to improve browsing experience, analyze traffic, and personalize content. By continuing to use our site, you consent to the use of cookies. You can disable cookies in your browser settings, but some features may not work properly.</p>
            </div>
          </motion.div>
        </motion.section>
      </div>
    </div>
  );
};

export default Cookies;
